// gb-cart-drawer.js
// Warenkorb-Drawer: öffnet sich beim Klick auf das Warenkorb-Icon im Header,
// zeigt den aktuellen Inhalt (via /cart.js), erlaubt Mengenänderung/Entfernen
// direkt im Drawer, und verlinkt über "Warenkorb ansehen" zur vollen
// Cart-Page (gb-cart-page.liquid).

// ---- AUTO-KILLER für dünne fix/sticky Balken ----
// Findet automatisch JEDES fix/sticky positionierte Element, das dünn ist
// (wie eine Linie/Leiste) und eine sichtbare Hintergrundfarbe hat, und
// entfernt es sofort — unabhängig davon was es ist oder von welcher App/
// welchem Theme-Feature es kommt. Läuft beim Laden UND bei jeder DOM-
// Änderung, damit auch nachträglich eingefügte Elemente erwischt werden.
(function () {
  function isOurs(el) {
    return el.closest('[data-gb-cartdrawer], [data-gb-search-overlay], .gb-mobile, gb-mega-header');
  }

  function killThinBars() {
    document.querySelectorAll('body *').forEach(function (el) {
      if (isOurs(el)) return;
      var s = getComputedStyle(el);
      if (s.position !== 'fixed' && s.position !== 'sticky') return;
      var bg = s.backgroundColor;
      if (!bg || bg === 'rgba(0, 0, 0, 0)' || bg === 'transparent') return;
      var r = el.getBoundingClientRect();
      // "Dünne Leiste": sehr niedrig aber breit, ODER sehr schmal aber hoch
      var isThinBar = (r.height > 0 && r.height <= 20 && r.width >= 100) ||
                       (r.width > 0 && r.width <= 20 && r.height >= 100);
      if (isThinBar && r.width > 0 && r.height > 0) {
        el.style.setProperty('display', 'none', 'important');
        el.setAttribute('data-gb-killed-thin-bar', '1');
      }
    });
  }

  killThinBars();
  window.addEventListener('load', function () { setTimeout(killThinBars, 800); setTimeout(killThinBars, 2500); });
  if (window.MutationObserver) {
    var debounce;
    new MutationObserver(function () {
      clearTimeout(debounce);
      debounce = setTimeout(killThinBars, 200);
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
// ---- ENDE AUTO-KILLER ----

(function () {
  var root = document.querySelector('[data-gb-cartdrawer]');
  if (!root) return;

  var body = root.querySelector('[data-gb-cartdrawer-body]');
  var loadingEl = root.querySelector('[data-gb-cartdrawer-loading]');
  var emptyEl = root.querySelector('[data-gb-cartdrawer-empty]');
  var itemsEl = root.querySelector('[data-gb-cartdrawer-items]');
  var footerEl = root.querySelector('[data-gb-cartdrawer-footer]');
  var subtotalEl = root.querySelector('[data-gb-cartdrawer-subtotal]');

  function money(cents) {
    var value = cents / 100;
    var fixed = value.toFixed(2);
    var parts = fixed.split('.');
    var withThousands = parts[0].replace(/^-/, '').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    var sign = value < 0 ? '-' : '';
    return sign + withThousands + ',' + parts[1] + ' €';
  }

  function escapeHtml(str) {
    return (str || '').replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function itemHtml(item) {
    var variantLine = (item.variant_title && item.variant_title !== 'Default Title')
      ? '<p class="gb-cartdrawer-item__variant">' + escapeHtml(item.variant_title) + '</p>'
      : '';
    return '' +
      '<div class="gb-cartdrawer-item" data-key="' + item.key + '">' +
        '<a href="' + item.url + '" class="gb-cartdrawer-item__img">' +
          (item.image ? '<img src="' + item.image + '" alt="' + escapeHtml(item.product_title) + '" loading="lazy">' : '') +
        '</a>' +
        '<div class="gb-cartdrawer-item__body">' +
          '<a href="' + item.url + '" class="gb-cartdrawer-item__title">' + escapeHtml(item.product_title) + '</a>' +
          variantLine +
          '<div class="gb-cartdrawer-item__row">' +
            '<div class="gb-cartdrawer-qty">' +
              '<button type="button" class="gb-cartdrawer-qty__btn" data-decrease aria-label="Menge verringern">−</button>' +
              '<span class="gb-cartdrawer-qty__value">' + item.quantity + '</span>' +
              '<button type="button" class="gb-cartdrawer-qty__btn" data-increase aria-label="Menge erhöhen">+</button>' +
            '</div>' +
            '<span class="gb-cartdrawer-item__price">' + money(item.final_line_price) + '</span>' +
          '</div>' +
        '</div>' +
        '<button type="button" class="gb-cartdrawer-item__remove" data-remove aria-label="Entfernen">' +
          '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h18"/><path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/></svg>' +
        '</button>' +
      '</div>';
  }

  function render(cart) {
    loadingEl.hidden = true;
    if (!cart.item_count) {
      emptyEl.hidden = false;
      itemsEl.hidden = true;
      footerEl.hidden = true;
      return;
    }
    emptyEl.hidden = true;
    footerEl.hidden = false;
    itemsEl.hidden = false;
    itemsEl.innerHTML = cart.items.map(itemHtml).join('');
    subtotalEl.textContent = money(cart.total_price);
  }

  function fetchCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); });
  }

  function refresh() {
    fetchCart().then(render);
  }

  function changeQuantity(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(render);
  }

  function open() {
    root.hidden = false;
    document.body.style.overflow = 'hidden';
    loadingEl.hidden = false;
    itemsEl.hidden = true;
    emptyEl.hidden = true;
    footerEl.hidden = true;
    refresh();
  }

  function close() {
    root.hidden = true;
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    var openTrigger = e.target.closest('[data-gb-cart-open]');
    if (openTrigger) {
      e.preventDefault();
      open();
      return;
    }
    if (e.target.closest('[data-gb-cartdrawer-close]')) {
      close();
      return;
    }
    if (e.target === root) {
      close();
      return;
    }

    var itemRow = e.target.closest('.gb-cartdrawer-item');
    if (!itemRow) return;
    var key = itemRow.getAttribute('data-key');

    if (e.target.closest('[data-remove]')) {
      changeQuantity(key, 0);
      return;
    }
    if (e.target.closest('[data-increase]')) {
      var current = parseInt(itemRow.querySelector('.gb-cartdrawer-qty__value').textContent, 10) || 0;
      changeQuantity(key, current + 1);
      return;
    }
    if (e.target.closest('[data-decrease]')) {
      var current2 = parseInt(itemRow.querySelector('.gb-cartdrawer-qty__value').textContent, 10) || 0;
      changeQuantity(key, Math.max(0, current2 - 1));
      return;
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !root.hidden) close();
  });

  // ---- Produktseiten "In den Warenkorb"-Formulare abfangen ----
  // Shopify-Standardformulare für Add-to-Cart posten an eine Action, die
  // "/cart/add" enthält. Wir fangen den Submit ab, senden ihn per AJAX an
  // /cart/add.js, und öffnen danach den Drawer statt die Seite neu zu laden
  // bzw. zur Cart-Page zu navigieren.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/cart/add') === -1) return;

    e.preventDefault();

    var submitBtn = form.querySelector('[type="submit"]');
    var originalText = submitBtn ? submitBtn.textContent : null;
    if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = '…'; }

    var formData = new FormData(form);

    fetch('/cart/add.js', { method: 'POST', body: formData })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (err) { throw err; });
        return r.json();
      })
      .then(function () {
        if (submitBtn) { submitBtn.disabled = false; if (originalText) submitBtn.textContent = originalText; }
        open();
      })
      .catch(function () {
        // Falls z.B. ein Ausverkauft-Fehler kommt: normal weiterleiten,
        // damit die Standard-Fehlermeldung des Themes greift.
        if (submitBtn) { submitBtn.disabled = false; if (originalText) submitBtn.textContent = originalText; }
        form.submit();
      });
  });

  // Auch nicht-Formular-basierte Quick-Add-Buttons (z.B. im Such-Overlay
  // oder auf der Cart-Page-Cross-Sell), die bereits per fetch('/cart/add.js')
  // hinzufügen, können den Drawer danach öffnen, indem sie
  // window.gbOpenCartDrawer() aufrufen.

  // Für andere Skripte (z.B. Produktseiten-"In den Warenkorb"-Buttons)
  // aufrufbar machen, um den Drawer nach einem Add-to-Cart zu öffnen.
  window.gbOpenCartDrawer = open;
  window.gbRefreshCartDrawer = refresh;

  // ---- Nativen Theme-Cart-Drawer entfernen ----
  // Das Theme rendert weiterhin sein eigenes <cart-drawer>-Element im DOM
  // (mit eigenem "Lädt..."/Fortschrittsbalken-Widget einer App darin), das
  // per CSS nicht zuverlässig unterdrückt werden konnte (Spezifitäts-Kampf
  // mit Theme/App-CSS). Da unser eigener Drawer diese Rolle komplett
  // übernimmt, entfernen wir das native Element direkt aus dem DOM statt
  // es nur zu verstecken — das gewinnt garantiert gegen jede CSS-Regel.
  function removeNativeCartDrawer() {
    document.querySelectorAll('cart-drawer, #CartDrawer, .cart-drawer').forEach(function (el) {
      if (el.hasAttribute('data-gb-cartdrawer')) return; // unser eigener Drawer bleibt
      el.remove();
    });
  }
  removeNativeCartDrawer();
  // Falls das Theme es später (z.B. nach Cart-Update) erneut einfügt,
  // beobachten wir den <body> und entfernen es sofort wieder.
  if (window.MutationObserver) {
    new MutationObserver(function () { removeNativeCartDrawer(); })
      .observe(document.body, { childList: true, subtree: false });
  }
})();   